import { useState } from "react";
import { ChinaUrlCode, USUrlCode } from "../../utils/ControllerCostant";
import {
  chinaEmail,
  globalEmail,
  subject,
  usEmail,
} from "../../utils/constants";
import Modal from "../Modal";
import styles from "./styles.module.css";
import { useIntl } from "react-intl";
import PropTypes from 'prop-types';

const ContactSupportMailTo = ({ isExpanded, label, iconDefault }) => {
  const intl = useIntl();
  const [modalOpen, setModalOpen] = useState(false);
  const location = window.location.hostname;
  const reqLink = "https://bayersi.service-now.com/sp?id=sc_cat_item&sys_id=0256e45c2b840b94abe5fa97d891bf2d&sysparm_category=19cc324e1bc9d05007afddb7ab4bcb1d";
  let mailToLink;
  if (location.includes(USUrlCode))
    mailToLink = `mailto:${usEmail}?subject=${encodeURIComponent(subject)}`;
  else if (location.includes(ChinaUrlCode))
    mailToLink = `mailto:${chinaEmail}?subject=${encodeURIComponent(subject)}`;
  else
    mailToLink = `mailto:${globalEmail}?subject=${encodeURIComponent(subject)}`;
  return (
    <>
      <button
        onClick={() => {
          setModalOpen(true);
        }}
        className={`side-nav-link ${styles["navItem"]} ${isExpanded ? "expanded" : "collapsed"}`}
      >
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 align-self-center d-flex align-items-center p-0">
            <img
              alt="menu-icon"
              src={iconDefault}
              className="nav-menu-icon"
              title={!isExpanded ? label : ""}
              style={!isExpanded ? { margin: "auto" } : {}}
            />
            <span
              className={`nav-menu-text ${isExpanded ? "d-inline-block" : "d-none"
                }`}
            >
              {label}
            </span>
          </div>
        </div>
      </button>
      <Modal noActions title={intl.formatMessage({
        id: "contact.title",
        defaultMessage: "Contact Truman Support",
      })} open={modalOpen} setOpen={setModalOpen}>
        <div className={styles["support-container"]}>
          <p className={styles["support-subtitle"]}>{intl.formatMessage({
            id: "contact.subtitle",
            defaultMessage: "Running into an issue or need something new? Choose an option below and the Truman team will take it from there",
          })}</p>
          <div className={styles["card-wrapper"]}>
            <Card
              iconUrl="/ui/images/Truman-UI-add_shopping_cart-icon.svg"
              title={intl.formatMessage({
                id: "contact.incident_title",
                defaultMessage: "Submit an Incident"
              })}
              description={intl.formatMessage({
                id: "contact.incident_description",
                defaultMessage: "Something not working? Let us know and we'll look into it right away."
              })}
              buttonText={intl.formatMessage({
                id: "contact.incident_title",
                defaultMessage: "Submit an Incident"
              })}
              link={mailToLink}
            />
            <Card
              iconUrl="/ui/images/Truman-UI-construction-icon.svg"
              title={intl.formatMessage({
                id: "contact.request_title",
                defaultMessage: "Submit a Request"
              })}
              description={intl.formatMessage({
                id: "contact.request_description",
                defaultMessage: "Need something? Raise a request through IT4U and we'll get it sorted."
              })}
              buttonText={intl.formatMessage({
                id: "contact.request_title",
                defaultMessage: "Submit a Request"
              })}
              link={reqLink}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

ContactSupportMailTo.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  iconDefault: PropTypes.string.isRequired,
};

const Card = ({ iconUrl, title, description, buttonText, link }) => (
  <div className={styles["card"]}>
    <img src={iconUrl} alt={title} />
    <div className={styles["card-text-wrapper"]}>
      <p className={styles["card-title"]}>{title}</p>
      <p className={styles["card-description"]}>{description}</p>
    </div>
    <Link link={link} label={buttonText} />
  </div>
);

Card.propTypes = {
  iconUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

const Link = ({ link, label }) => (
  <a className={styles["link"]} target="_blank" rel="noopener noreferrer" href={link}>
    {label}
  </a>
);

Link.propTypes = {
  link: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default ContactSupportMailTo;